var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGElections/MyADGElections.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGElections/MyADGElections.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "data") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"))) {
t_5 += "\n        <div class=\"MyADGElections\">\n            <h2>";
t_5 += runtime.suppressValue((lineno = 6, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["warning","0 0 100 100",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_5 += "</h2>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"updated")) {
t_5 += "\n                <div class=\"MyADGElections-lastUpdated\">\n                    <span>Last Updated ";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"updated"),"%m/%d/%y"), env.opts.autoescape);
t_5 += "</span>\n                </div>\n            ";
;
}
t_5 += "\n\n            <div class=\"MyADGElections-columns\">\n\n                <div class=\"MyADGElections-column-1\">\n                    ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")), env.opts.autoescape);
t_5 += "\n                </div>\n\n                <div class=\"MyADGElections-column-2\">\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"))) {
t_5 += "\n                        <div class=\"MyADGElections-downloads\">\n                            <ul class=\"MyADGElections-downloadsList\">\n                                ";
frame = frame.push();
var t_10 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"release")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"):"");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("item", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
t_5 += "<li class=\"MyADGElections-downloadsListItem\">\n                                        <a class=\"MyADGElections-downloadsListItemLink\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_11),"release"), env.opts.autoescape);
t_5 += "\">\n                                        <div class=\"MyADGElections-downloadsListItemTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_11),"title"), env.opts.autoescape);
t_5 += "</div>\n                                        <div class=\"MyADGElections-downloadsListItemArrow\">\n                                            ";
t_5 += runtime.suppressValue((lineno = 29, colno = 66, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
t_5 += "\n                                        </div>\n                                        </a>\n                                    </li>\n                                ";
;
}
}
frame = frame.pop();
t_5 += "\n                            </ul>\n                        </div>\n                    ";
;
}
t_5 += "\n                </div>\n            </div>\n        </div>\n    ";
;
}
t_5 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MyADGElections");
context.setVariable("MyADGElections", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGElections/MyADGElections.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGElections/MyADGElections.jinja
// module id = 504
// module chunks = 0